module.exports = {"dsClientUrl":"wss://deepstream.triled.be","triviewApiUrl":"https://triviewapiv2-staging.triled.be","isBeta":false};